var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuTasksDashboard = function SvgMenuTasksDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "86D60E08-8BA3-4975-A3C7-B58BDE4AFDAD")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-System",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    transform: "translate(-271.000000, -1240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-tasks-dashboard",
    transform: "translate(271.000000, 1240.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#D7DBF4",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#4659CE",
    strokeWidth: 0.975,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 16.5853659,
    height: 16.5,
    rx: 0.975
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4659CE",
    strokeWidth: 0.975,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 16.5853659,
    height: 16.5,
    rx: 0.975
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4659CE",
    x: 0,
    y: 0,
    width: 16.5,
    height: 3.2175
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 1.81920732,
    cy: 1.40765625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    fill: "#FFFFFF",
    cx: 3.84054878,
    cy: 1.40765625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-4",
    fill: "#FFFFFF",
    cx: 5.86189024,
    cy: 1.40765625,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.390244, 6.600000)",
    stroke: "#4659CE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    points: "0 2.46089229 2.02052203 4.125 5.3902439 0"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuTasksDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-tasks-dashboard.89e33f31.svg";
export { ForwardRef as ReactComponent };